import Card from 'antd/lib/card'

import 'antd/lib/card/style'

export * from 'antd/lib/card'

export default Card
